(() => {
  const HOST_SELECTOR =
    '[id*="__loox_reviews_loox_dynamic_carousel_"] loox-dynamic-carousel-widget';
  const EMPTY_CLASS = 'finch-loox-carousel-empty';
  const WATCHED_ATTRIBUTE = 'data-finch-loox-empty-watcher';
  const MAX_SHADOW_ROOT_ATTEMPTS = 200;

  function watchCarousel(host) {
    if (host.hasAttribute(WATCHED_ATTRIBUTE)) return;

    host.setAttribute(WATCHED_ATTRIBUTE, '');

    const block = host.closest('.shopify-app-block');
    if (!block) return;

    let attempts = 0;

    function connectToShadowRoot() {
      const shadowRoot = host.shadowRoot;

      if (!shadowRoot) {
        attempts += 1;

        if (attempts < MAX_SHADOW_ROOT_ATTEMPTS) {
          window.setTimeout(connectToShadowRoot, 50);
        }

        return;
      }

      function updateEmptyState() {
        const carousel = shadowRoot.querySelector(
          '.loox-dynamic-carousel-widget'
        );

        // Loox inserts this container only after its lazy render has started.
        if (!carousel) return;

        block.classList.toggle(EMPTY_CLASS, carousel.childElementCount === 0);
      }

      const observer = new MutationObserver(updateEmptyState);
      observer.observe(shadowRoot, {
        childList: true,
        subtree: true
      });

      updateEmptyState();
    }

    connectToShadowRoot();
  }

  function scan(root = document) {
    root.querySelectorAll(HOST_SELECTOR).forEach(watchCarousel);
  }

  function initialize() {
    if (!document.body.classList.contains('body-template-product')) return;

    scan();

    document.addEventListener('shopify:section:load', (event) => {
      scan(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
